import {
  Component,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  OnChanges,
  type SimpleChanges
} from '@angular/core';
import { NgbInputDatepicker, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, merge, Subject, BehaviorSubject, of } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap
} from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import {
  OBTAirportDetails,
  FastTrackEnterpriseSearchInterface,
  generateTimesList
} from '@sabstravtech/obtservices/base';
import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';

import { BaseComponent } from '../../../core/components/base_components/base-componet';
import { UiHelpers } from '../../../core/classes/ui-helpers';
import { DeviceDetector } from '../../../core/services/device-detector.service';

@Component({
  selector: 'app-fast-track-search',
  templateUrl: './fast-track-search.component.html',
  styleUrls: ['./fast-track-search.component.scss'],
  standalone: false
})
export class FastTrackSearchComponent extends BaseComponent implements OnInit, OnChanges {
  @ViewChildren(NgbInputDatepicker) datepickerList: QueryList<NgbInputDatepicker>;
  @ViewChild('inputAirport') inputAirport: NgbTypeahead;

  timesArray: string[];
  loadingAirports = false;
  airportsClick$: Subject<string> = new Subject();
  airportsFocus$: Subject<string> = new Subject();
  airportsList: Observable<OBTAirportDetails[]>;

  isArrivalLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  searchParameters: FastTrackEnterpriseSearchInterface = null;

  constructor(
    public deviceDetector: DeviceDetector,
    public searchService: EnterpriseSearchService,
    title: Title,
    public translateService: TranslateService
  ) {
    super(title, translateService);
  }

  ngOnInit(): void {
    this.searchParameters = this.searchService.searches[ServiceType.FastTrack];
    this.timesArray = generateTimesList(0, 24);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }

  @HostListener('document:click', ['$event'])
  onClick(event): void {
    UiHelpers.closeOpenCalendars(this.datepickerList, event);
  }
  formatAirports = (airport: OBTAirportDetails) =>
    airport.destination ? `${airport.destination} (${airport.gateway})` : '';

  getAirports = (text$: Observable<string>): Observable<OBTAirportDetails[]> => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.airportsClick$.pipe(
      filter(() => !this.inputAirport.isPopupOpen())
    );

    return merge(debouncedText$, this.airportsFocus$, clicksWithClosedPopup$).pipe(
      switchMap(
        (term) =>
          (this.airportsList = this.searchService
            .getAirportsList(term, null, null, null, null, true)
            .pipe(
              map((airports: OBTAirportDetails[]) => {
                return airports.filter((airport) => airport.gateway !== 'LGW'); // Gatwick no longer wanted for fast track
              }),
              catchError(() => of([]))
            ))
      )
    );
    // tslint:disable-next-line: semicolon
  };

  ensureElementIsScrolledTo(event) {
    try {
      const typeAheadList = event.target.nextElementSibling;
      const activeButton = typeAheadList.getElementsByClassName('active')[0];
      if (
        activeButton.offsetTop + activeButton.clientHeight >
        typeAheadList.clientHeight + typeAheadList.scrollTop
      ) {
        typeAheadList.scrollTop =
          activeButton.offsetTop + activeButton.clientHeight - typeAheadList.clientHeight;
      } else if (activeButton.offsetTop < typeAheadList.scrollTop) {
        typeAheadList.scrollTop = activeButton.offsetTop;
      }
    } catch (e) {
      // tslint:disable-next-line: quotemark
      console.warn("Couldn't find elements to scroll");
    }
  }
}
